import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#171717",
      "stroke-linecap": "round",
      "stroke-width": "2",
      d: "M1.833 1.833 11 11M20.167 1.833 11 11"
    }, null, -1)
  ]))]))
}
export default { render: render }